export const reviewsData = [
  {
    link: "https://www.google.com/maps/place/Tomedes+Translation+Services/@45.4521673,-122.7919442,17z/data=!3m1!4b1!4m5!3m4!1s0x54950d8bd3c5960d:0xecfe82a87609c06e!8m2!3d45.4521673!4d-122.7919442",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664191372google-us.svg",
    alt: "google reviews USA",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664191354google-il.svg",
    alt: "google reviews Israel",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664346474clutch.svg",
    alt: "clutch reviews",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664191321goodfirms.svg",
    alt: "goodfirms reviews",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664191426trustpilot.svg",
    alt: "trustpilot reviews",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664346519g2.png",
    alt: "g2 reviews",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664191195facebook.png",
    alt: "fb reviews",
  },
  {
    link: "",
    src: "https://tomedes.gumlet.io/S3UploadedFiles/1664191256featured.svg",
    alt: "featured reviews",
  },
];
